<template>
    <div>
        <b-row class="mt-2">
            <b-col md="8">
                <b-form-group>
                <b-form-input
                    v-model="consultarreceta"
                    placeholder="Buscar por cedula o nombre del paciente o doctor."
                    type="text"
                    class="d-inline-block"
                />
                </b-form-group>
            </b-col>
            <b-col md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <b-form-group class="w-100">
                <v-select
                    id="especialidad"
                    v-model="consultarespecialidad"
                    :options="especialidades"
                    placeholder="Buscar por especialidad."
                    :reduce="option => option.value"
                    label="text"
                    class="d-inline-block w-100"
                />
            </b-form-group>
        </b-col>
         <!-- Selector de Fecha Desde -->
      <b-col md="2">
        <b-form-group class="mb-0">
          <b-form-datepicker
            v-model="fechaDesde"
            placeholder="Desde"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>

      <!-- Selector de Fecha Hasta -->
      <b-col md="2">
        <b-form-group class="mb-0">
          <b-form-datepicker
            v-model="fechaHasta"
            placeholder="Hasta"
          ></b-form-datepicker>
        </b-form-group>
      </b-col>
            <b-col v-if="esAdmin" md="3" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <b-form-group class="w-100">
                    <v-select
                        id="establecimiento"
                        v-model="consultarestablecimiento"
                        :options="establecimientos"
                        placeholder="Buscar por establecimiento."
                        :reduce="option => option.value"
                        label="text"
                        class="d-inline-block w-100"
                    />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="4" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                <b-button variant="primary" @click="buscarReceta">
                        <font-awesome-icon icon="magnifying-glass" style="color: white;"  /> <span style="color: white;">
                        buscar</span>
                </b-button>
            </b-col>
        </b-row>
        <b-overlay
          :show="mostrarLoader"
          opacity="0.50"
          rounded="sm"
        >
            <b-card class="principal">
            <b-col
              cols="12"
              class="pr-0 pl-0 mt-2"
            >
            <b-table
                v-if="items.length > 0"
                bordered
                striped
                responsive
                :per-page="perPage"
                :current-page="currentPage"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
                >
                <template #cell(acciones)="data">
                    <div class="d-flex justify-content-end">
                    <!-- Asegúrate de usar la propiedad correcta aquí, por ejemplo, `idMedicamento` -->
                    <b-button variant="warning" size="sm" @click="viewItem(data.item.idReceta)">
                        <i class="fas fa-pills"></i>
                    </b-button>
                    <b-button variant="danger" size="sm" @click="removeItemid(data.item.idReceta)">
                        <font-awesome-icon icon="circle-xmark" style="color: white;" title="Eliminar receta" />
                    </b-button>
                    </div>
                </template>
                </b-table>
              <div v-else class="text-center">
                <p>No se encontraron registros</p>
              </div>
            </b-col>

            <b-col
              cols="12"
              class="mb-2"
            >
              <b-pagination
                        v-if="items.length > 0"
                        v-model="currentPageModificado"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        :small="true"
                        first-number
                        last-number
                        class="mb-0"
                        align="center"
                        prev-class="prev-item"
                        next-class="next-item"
                        @change="cambiarPagina"
                    >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-card>
        </b-overlay>
    </div>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BOverlay, 
    BFormGroup, 
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
} from 'bootstrap-vue'
import actions from '@/assets/utils/utils'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'
import axios from 'axios';
import { comprobarPermisos } from "@/shared/helpers";
import rutas from '@/assets/utils/rutas.json';

export default {
    components: {
        BCard,
        BCardCode,
        BRow,
        BCol, 
        BFormGroup,
        BFormInput,
        BButton,
        BTable,
        BMedia,
        BAvatar,
        BOverlay,
        BLink,
        BBadge,
        BDropdown,
        BDropdownItem,
        BPagination,
        BTooltip,
        vSelect,
    },
    data() {
        
        return {
            consultarespecialidad: "",
            codG: [
                '0000000001'
            ],
            esAdmin : false,
            fechaDesde: null,
            fechaHasta: null,
            especialidades: [],
            pagina_actual:1,
            currentPage: 1,
            currentPageModificado:1,
            mostrarLoader: false,
            login_user: '',
            consultarreceta:null,
            consultarestablecimiento:'',
            establecimientos: [],
            establecimiento:'',
            perPage: 15,
            pageOptions: [3, 5, 10],
            totalRows: 3,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,
            filterOn: [],
            infoModal: {
                id: 'info-modal',
                title: '',
                content: '',
            },
            fields: [
                { key: 'cedula', label: 'Cédula', sortable: true, thClass: 'text-center' },
                { key: 'paciente', label: 'Paciente', sortable: true, thClass: 'text-center' },
                { key: 'usuarioCreador', label: 'Usuario', sortable: true, thClass: 'text-center', width: '150px' },
                { key: 'doctor', label: 'Doctor', sortable: true, thClass: 'text-center' },
                { key: 'especialidad', label: 'Especialidad', sortable: true, thClass: 'text-center' },
                { key: 'fecha', label: 'Fecha de Emisión', sortable: true, thClass: 'text-center' },
                { key: 'acciones', label: 'acciones', sortable: true, thClass: 'text-center', tdClass: 'text-right' },            
            ],
            listaAcciones: [],
            token_usuario: '',
            configdateTimePicker: {
                enableTime: false,
                dateFormat: 'd/m/Y',
            },
            items: [],
            descripcion: '',
        } 
    },
    created() {
        comprobarPermisos(this.$route);
        this.fetchConsultarReceta()
        this.setToken();
        this.fetchEstablecimientos();
        this.fetchEspecialidades();

    },
    mounted() {
        actions.setearTitulo('Receta')

    },

    methods: {
        
        async fetchEspecialidades() {
            const query = `
                        query {
                            allEspecialidad {
                                id
                                descripcion
                            }
                        }
                    `;
            try {
                const response = await axios.post(rutas.axios + 'api', { query });
                this.especialidades = response.data.data.allEspecialidad.map(item => ({
                    value: item.id,
                    text: item.descripcion
                }));
            } catch (error) {
                console.error('An error occurred while fetching the options:', error);
            }
        },
       
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
        },
        cambiarPagina(pagina_actual) {
            // Actualizar currentPage con el nuevo número de página
            this.currentPage = pagina_actual;
            const establecimientoValue = this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '';
            this.fetchConsultarReceta(this.consultarreceta ? this.consultarreceta : '', this.currentPage, establecimientoValue, this.perPage, this.consultarespecialidad, this.fechaDesde, this.fechaHasta);
        },
        async fetchEstablecimientos() {
            const query = `
                        query {
                            allEstablecimientos {
                                id
                                Descripcion
                                uniCodigo
                            }
                        }
                    `;
            try {
                const response = await axios.post(rutas.axios + 'api', { query });
                this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
                    value: item.id,
                    text: item.Descripcion,
                    uniCodigo: item.uniCodigo
                }));
            } catch (error) {
                console.error('An error occurred while fetching the options:', error);
            }
        },

        async fetchConsultarReceta(search = '', pagina_actual = 1, establecimiento = '', pageSize, especialidad = '', fechaDesde, fechaHasta) {
            let user = JSON.parse(localStorage.getItem('detalleusuario'))
            
            let estab = user.establecimiento ? user.establecimiento.id : ""
            user.roles.forEach(i => {
            if (this.codG.includes(i.codigo)) {
                
                estab = '0'
                this.esAdmin = true
            }})
            
            const query = `
            query ConsultarRecetas($search: String, $establecimiento: String, $page: Int, $pageSize: Int, $especialidad : ID, $fechaDesde : Date, $fechaHasta : Date) {
                allReceta(search: $search, establecimiento: $establecimiento, page: $page, pageSize: $pageSize, especialidad : $especialidad, fechaDesde : $fechaDesde, fechaHasta : $fechaHasta) {
                    total
                    status
                    message
                    recetas {
                        id
                        fechaCreacion
                        usuarioCreador{
                            username
                        }
                        estadoTransitorio
                        consultamedica{
                            cita{
                                id
                                establecimiento{
                                    id
                                    Descripcion
                                }
                                doctor{
                                    especialidad{
                                        descripcion
                                    }
                                    idPersona{
                                        primerNombre
                                        identificacion
                                        primerApellido
                                    }
                                }
                                paciente{
                                    persona{
                                        primerNombre
                                        identificacion
                                        primerApellido
                                    }
                                }
                            }
                        }
                    }
                    pageInfo {
                    currentPage
                    totalPages
                    hasNextPage
                    hasPreviousPage
                    }
                }
                }
            `;
            const var_consulta = {
                search: search,
                page: pagina_actual,
                pageSize: pageSize,
                establecimiento: estab.toString(),
                especialidad : this.consultarespecialidad,
                fechaDesde : this.fechaDesde,
                fechaHasta : this.fechaHasta
            }
            try {
                const response = await axios.post(rutas.axios + 'api', { query, variables: var_consulta });
                if (response.status === 200) {
                    if (response.data.data.allReceta.status === 'Success') {
                        if (response.data.data.allReceta.recetas) {
                            console.log(response.data.data.allReceta.recetas)
                            this.items = response.data.data.allReceta.recetas.map(item => {
                                return {
                                    idReceta: item.id,
                                    usuarioCreador: item.usuarioCreador ? item.usuarioCreador.username : 'No disponible',
                                    cedula: item.consultamedica && item.consultamedica.cita && item.consultamedica.cita.establecimiento ? item.consultamedica.cita.establecimiento.Descripcion : 'No disponible',
                                    cedula: item.consultamedica && item.consultamedica.cita && item.consultamedica.cita.paciente && item.consultamedica.cita.paciente.persona ? item.consultamedica.cita.paciente.persona.identificacion : 'No disponible',
                                    paciente: item.consultamedica && item.consultamedica.cita && item.consultamedica.cita.paciente && item.consultamedica.cita.paciente.persona ? item.consultamedica.cita.paciente.persona.primerNombre + " " + item.consultamedica.cita.paciente.persona.primerApellido : 'No disponible',
                                    doctor: item.consultamedica && item.consultamedica.cita && item.consultamedica.cita.doctor && item.consultamedica.cita.doctor.idPersona ? item.consultamedica.cita.doctor.idPersona.primerNombre + " " + item.consultamedica.cita.doctor.idPersona.primerApellido : 'No disponible',
                                    estadoTransitorio: item.estadoTransitorio,
                                    fecha: new Date(item.fechaCreacion).toLocaleString("pt-BR"),
                                    especialidad: item.consultamedica && item.consultamedica.cita && item.consultamedica.cita.doctor && item.consultamedica.cita.doctor.especialidad ? item.consultamedica.cita.doctor.especialidad.descripcion : 'No disponible'
                                };
                            });

                            this.totalRows = response.data.data.allReceta.total;
                            this.currentPage = 1;
                            this.currentPageModificado = pagina_actual
                        } else {
                            console.log("No se encontraron recetas");
                            // Aquí podrías establecer un mensaje en la interfaz de usuario
                        }
                    } else {
                        console.log("Error en la respuesta del servidor");
                        // Manejo del error de respuesta del servidor
                    }
                }
            } catch (error) {
                console.error("Error fetching recetas:", error);
                // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
            }
        },
        buscarReceta() {
            const establecimientoValue = this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '';
            this.fetchConsultarReceta(this.consultarreceta,this.currentPage, establecimientoValue,15,'','', this.consultarespecialidad, this.fechaDesde, this.fechaHasta);
        },

        viewItem(idReceta) {
            this.$router.push({
                name: 'retirar_receta',
                params: { id: idReceta }
            });
        },
        setToken() {
            const user = JSON.parse(localStorage.getItem('usuario'))
            this.login_user = user.username
            axios.defaults.headers.common.Authorization = `JWT ${user.token}`
        },
        
        info(item, index, button) {
            this.infoModal.title = `Row index: ${index}`
            this.infoModal.content = JSON.stringify(item, null, 2)
            this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
    },
    
}
</script>
